import React, { useState, useEffect, useRef, useMemo } from 'react';
import { ShoppingCart, Plus, Package, Users, LayoutGrid, Trash2, X, Search, Camera, Receipt, Save,
  Minus, Image as ImageIcon, BarChart3, Settings, Printer, Clock, ArrowUpRight, Edit3,
  FileText, Download, AlertTriangle, Ban, UserCheck, Share2, Copy, AlertOctagon, RefreshCw, Truck,
  RotateCcw, ChevronLeft, ChevronRight, ScanBarcode, UserCircle2, Layers, Lock, LogIn, Menu, LogOut,
  HelpCircle, CheckSquare, Square, MapPin, Phone, PauseCircle, PlayCircle, AlertCircle, Banknote,
  CreditCard, Smartphone, BookOpen, Crown, Unlock, Globe, Wallet, History, FileCheck, Boxes, PenLine,
  CreditCard as CardIcon, Store, ArrowRightLeft, UserCog, Briefcase, FileOutput, Megaphone, UserPlus,
  Link, MonitorSmartphone, Contact, FileMinus } from 'lucide-react';
import { apiCall, generateId, formatPrice, formatDate, compressImage,
  base64ToFile, printHtmlDiv, printRawHtml, printBarcodeDiv } from '../utils/utils.js';

const NavButton = ({ view, target, icon: Icon, label, setView, isSidebarOpen, setIsSidebarOpen }) => {
    const active = view === target;
    return (
        <button
            onClick={() => { setView(target); if (window.innerWidth < 768) setIsSidebarOpen(false); }}
            className={`relative w-full p-3 rounded-lg mb-1.5 flex flex-col items-center gap-1 transition-all duration-150 ${active ? 'bg-[#262626] text-white' : 'text-[#8c8c8c] hover:bg-[#242424] hover:text-white'}`}
        >
            {active && <span className="absolute left-0.5 top-1/2 -translate-y-1/2 w-1 h-5 rounded-full bg-[#008060]" />}
            <Icon size={22} strokeWidth={active ? 2.25 : 1.75} />
            <span className={`text-[10px] tracking-wide ${active ? 'font-semibold' : 'font-medium'}`}>{label}</span>
        </button>
    );
};

const EmptyState = ({ icon: Icon, title, message, actionLabel, onAction }) => (
    <div className="flex flex-col items-center justify-center py-16 px-4 text-center border border-dashed border-[#d1d3d6] rounded-xl bg-white">
        <div className="w-16 h-16 bg-[#f6f7f8] text-[#5c5f62] rounded-full flex items-center justify-center mb-4"><Icon size={32}/></div>
        <h3 className="text-lg font-semibold mb-2 text-[#1a1a1a]">{title}</h3>
        <p className="text-[#5c5f62] max-w-sm mx-auto mb-6 text-sm">{message}</p>
        {actionLabel && <button onClick={onAction} className="bg-[#008060] text-white px-5 py-2 rounded-lg font-semibold flex items-center gap-2 text-sm hover:bg-[#006e52] shadow-sm"><Plus size={16}/> {actionLabel}</button>}
    </div>
);

const UIComponents = { NavButton, EmptyState };
export default UIComponents;
